/* External dependencies */
import CognitoClient from '@mancho.devs/cognito';
import { Epic, ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators';

/* Local dependencies */
import {
  AuthAction,
  AuthActionType,
  confirmPasswordFail,
  ConfirmPasswordRequestAction,
  confirmPasswordSuccess,
  forgotPasswordFail,
  ForgotPasswordRequestAction,
  forgotPasswordSuccess,
  signInFail,
  SignInRequestAction,
  signInSuccess,
  signOutFail,
  SignOutRequestAction,
  signOutSuccess,
  signUpConfirmCodeFail,
  SignUpConfirmCodeRequestAction,
  signUpConfirmCodeSuccess,
  signUpFail,
  SignUpRequestAction,
  signUpSuccess,
} from './authAction';

const cognitoClient = new CognitoClient({
  UserPoolId: process.env.GATSBY_COGNITO_USER_POOL_ID,
  ClientId: process.env.GATSBY_COGNITO_CLIENT_ID,
});

export const signUpEpic: Epic<AuthAction, AuthAction> = (action$) =>
  action$.pipe(
    ofType(AuthActionType.SIGN_UP_REQUEST),
    switchMap((action: SignUpRequestAction) =>
      cognitoClient
        .signUp(action.payload.email, action.payload.password)
        .then(() => signUpSuccess())
        .catch((err: any) => signUpFail(err.message)),
    ),
  );

export const signInEpic: Epic<AuthAction, AuthAction> = (action$) =>
  action$.pipe(
    ofType(AuthActionType.SIGN_IN_REQUEST),
    switchMap((action: SignInRequestAction) =>
      cognitoClient
        .signIn(action.payload.email, action.payload.password)
        .then(() => signInSuccess())
        .catch((err: any) => signInFail(err.message)),
    ),
  );

export const forgotPasswordEpic: Epic<AuthAction, AuthAction> = (action$) =>
  action$.pipe(
    ofType(AuthActionType.FORGOT_PASSWORD_REQUEST),
    switchMap((action: ForgotPasswordRequestAction) =>
      cognitoClient
        .forgotPassword(action.payload.email)
        .then(() => forgotPasswordSuccess())
        .catch((err: any) => forgotPasswordFail(err.message)),
    ),
  );

export const confirmPasswordEpic: Epic<AuthAction, AuthAction> = (action$) =>
  action$.pipe(
    ofType(AuthActionType.CONFIRM_PASSWORD_REQUEST),
    switchMap((action: ConfirmPasswordRequestAction) =>
      cognitoClient
        .confirmPassword(action.payload.email, action.payload.code, action.payload.password)
        .then(() => confirmPasswordSuccess())
        .catch((err: any) => confirmPasswordFail(err.message)),
    ),
  );

export const signUpConfirmCodeEpic: Epic<AuthAction, AuthAction> = (action$) =>
  action$.pipe(
    ofType(AuthActionType.SIGN_UP_CONFIRM_CODE_REQUEST),
    switchMap((action: SignUpConfirmCodeRequestAction) =>
      cognitoClient
        .signUpConfirmCode(action.payload.email, action.payload.code)
        .then(() => signUpConfirmCodeSuccess())
        .catch((err: any) => signUpConfirmCodeFail(err.message)),
    ),
  );
export const signOutEpic: Epic<AuthAction, AuthAction> = (action$) =>
  action$.pipe(
    ofType(AuthActionType.SIGN_OUT_REQUEST),
    switchMap(() =>
      cognitoClient
        .signOut()
        .then(() => signOutSuccess())
        .catch((error: Error) => signOutFail(error)),
    ),
  );
